import { motion } from "framer-motion";

export function StatCard({ label, value, icon: Icon, hint, accent, testid }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      data-testid={testid}
      className="vp-card rounded-xl p-5 hover-lift hover:border-[var(--vp-accent)]/40"
    >
      <div className="flex items-start justify-between">
        <span className="overline-label text-slate-400">{label}</span>
        {Icon && (
          <span className="h-9 w-9 rounded-lg grid place-items-center" style={{ background: "rgba(61,187,44,0.12)" }}>
            <Icon size={18} className="vp-accent-text" />
          </span>
        )}
      </div>
      <div className="mt-3 text-2xl sm:text-3xl font-semibold mono text-white">{value}</div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </motion.div>
  );
}

export default StatCard;
